import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import { PageWrapper } from 'components/PageWrapper';
import Form from '../components/McqThemeForm';
import { MCQ_THEME_CONSTRAINS } from 'constants/adminPupups';

const MCQ_THEME_API = '/api/v1/themes/';

@inject('mcqThemesStore')
@inject('alertStore')
@observer
class Edit extends Component {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const {match, mcqThemesStore: {setMcqTheme}} = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${MCQ_THEME_API}${id}`).then(data => {
        const theme = data.body.data.theme;

        setMcqTheme(theme);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  validationProcess = resource => {
    let errors = validate(resource, MCQ_THEME_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {mcqThemesStore, match} = this.props;
    const id = match.params.id;
    const theme = _.assign({}, mcqThemesStore.mcq_theme);
    const errors = this.validationProcess(theme);

    mcqThemesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', theme.title);

    new HttpClient().multipart(`${MCQ_THEME_API}${id}`, formData, 'PUT').then(data => {
      mcqThemesStore.saveMcqTheme(data.body.data.theme);
      this.props.alertStore.success('You successfully edited MCQ Theme');
      this.props.history.push('/mcq-themes');
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  deleteQuestion = () => {
    const { alertStore, history, match } = this.props;
    const id = match.params.id;

    new HttpClient().delete(`${MCQ_THEME_API}${id}`)
    .then(() => {
      alertStore.success('You successfully delete theme');
      history.push('/mcq-themes');
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  render() {
    const { isConfirmModalOpened } = this.state;

    return (
      <PageWrapper>
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this theme?'
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.deleteQuestion}
            >
              Yes
            </button>
          </div>
        </Dialog>
        <button onClick={this.handleOpenConfirmModal} className='delete-btn'>delete question</button>
        <Form submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqThemes/containers/Edit.js